import React from 'react';
import { activityTypes, statusEnum } from '../../../../../helper/constants.helper';
import { Button } from '@mui/material';

const SelfAssessmentButtons = ({ historyItem, handleClick }) => {
  return (
    <>
      {historyItem.type === activityTypes.SELF_ASSESSMENT &&
        historyItem.status === statusEnum.COMPLETED &&
        historyItem.share_report === true && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            fullWidth
            size="small"
            style={{
              display: `${historyItem.type === activityTypes.MEETING ? 'none' : 'flex'}`,
              maxHeight: '50px'
            }}>
            View Report
          </Button>
        )}
      {historyItem.type === activityTypes.SELF_ASSESSMENT &&
        historyItem.status === statusEnum.INITIATED && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            fullWidth
            size="small"
            style={{
              display: `${historyItem.type === activityTypes.MEETING ? 'none' : 'flex'}`,
              maxHeight: '50px'
            }}>
            Start assessment
          </Button>
        )}
    </>
  );
};

export default SelfAssessmentButtons;
